import { DocLayout } from "#/components/docs/DocLayout";
import { JsonLdScript, buildArticleJsonLd } from "#/components/docs/JsonLd";
import { createT } from "#/lib/i18n";
import { canonicalUrl } from "#/lib/seo/canonical.js";

type Props = {
  locale: string;
  pageId: string;
  breadcrumbs: Array<{ label: string; href?: string }>;
  lastReviewedAt: string;
  reviewedBy: string;
  title: string;
  description: string;
};

export function GenericDocPage({
  locale,
  pageId,
  breadcrumbs,
  lastReviewedAt,
  reviewedBy,
  title,
  description,
}: Props) {
  const t = createT(locale, "docs");
  const jsonLd = buildArticleJsonLd({
    headline: title,
    description,
    url: canonicalUrl(`/docs/user/${pageId}`, locale),
    inLanguage: locale,
    dateModified: lastReviewedAt,
    authorName: reviewedBy,
  });

  const localisedBreadcrumbs = breadcrumbs.map((crumb) => ({
    ...crumb,
    label: crumb.href
      ? (t(`nav.${crumb.label}`) ?? crumb.label)
      : (t(`pages.${pageId}.title`) ?? crumb.label),
  }));

  return (
    <>
      <JsonLdScript data={jsonLd} />
      <DocLayout
        locale={locale}
        breadcrumbs={localisedBreadcrumbs}
        lastReviewedAt={lastReviewedAt}
        reviewedBy={reviewedBy}
      >
        <h1>{title}</h1>
        <div
          dangerouslySetInnerHTML={{
            __html: t(`pages.${pageId}.body`) ?? "",
          }}
        />
      </DocLayout>
    </>
  );
}
